export default "__VITE_ASSET__kPkCX52A__"